<template>
    <div class="list-container">
        <h2>Manage Days</h2>
        <button class="btn btn-sm add-btn" @click="$router.push('/dashboard/days/create')">Add Day</button>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <ul v-else class="data-list">
            <li v-for="day in days" :key="day.id" class="list-item">
                <div class="item-info">
                    <span class="info-item"><strong>Day Name:</strong> {{ day.name }}</span>
                </div>
                <div class="btn-group">
                    <button class="btn btn-sm edit-btn" @click="$router.push(`/dashboard/days/edit/${day.id}`)">✏️
                        Edit</button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            days: [],
            loading: false
        };
    },
    methods: {
        async fetchDays() {
            this.loading = true;
            try {
                const response = await this.$api.get('/days');
                this.days = response.data;
            } catch (error) {
                console.error("Error fetching days:", error);
            }
            this.loading = false;
        }
    },
    mounted() {
        this.fetchDays();
    }
};
</script>

<style scoped>
.list-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
